module.exports = __webpack_public_path__ + "static/img/10-10.2a6c913b.jpeg";